import { render, staticRenderFns } from "./EditShiftType.vue?vue&type=template&id=f4336768&"
import script from "./EditShiftType.vue?vue&type=script&lang=ts&"
export * from "./EditShiftType.vue?vue&type=script&lang=ts&"
import style0 from "./EditShiftType.vue?vue&type=style&index=0&id=f4336768&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports